// extracted by mini-css-extract-plugin
export default {"wrapper":"jp-z","response":"kp-z","error":"lp-z","disabled":"mp-z","buttons":"np-z","feedbackQuestionSection":"op-z","yesNoWrapper":"pp-z"};